import { Card, CardContent, CardTitle } from '@/components/ui/Card.tsx';
import { BookingPublicSummaryDto } from '@/features/public/bookingSummary/types/BookingPublicSummaryDto.ts';
import { BookingStatus } from '@/types/BookingStatus.ts';
import { cn } from '@/lib/utils.ts';
import timeUtils from '@/utils/timeUtils.ts';
import { CalendarDays, Check, CircleX, Users } from 'lucide-react';

interface BookingSummaryHeaderProps {
  data: BookingPublicSummaryDto;
}

const BookingSummaryHeader = ({ data }: BookingSummaryHeaderProps) => {
  const cancelled = data.bookingStatus === BookingStatus.CANCELLED;

  return (
    <Card>
      <CardContent className="flex flex-col gap-4">
        {data.organizerLogoUrl && (
          <img
            src={data.organizerLogoUrl}
            alt=""
            className="mb-2 h-8 self-start rounded object-contain"
          />
        )}
        <div
          className={cn(
            'mx-auto flex h-12 w-12 items-center justify-center rounded-md',
            cancelled ? 'bg-error-100' : 'bg-success-100',
          )}
        >
          {cancelled ? (
            <CircleX aria-hidden className="size-6 text-error-300" />
          ) : (
            <Check aria-hidden className="size-6 text-success-300" />
          )}
        </div>
        <CardTitle className="text-center">
          {cancelled ? 'Rezerwacja anulowana' : 'Zarezerwowano miejsce'}
        </CardTitle>
        {cancelled && (
          <p className="text-center text-sm text-neutral-500">
            {`W sprawie wpłat skontaktuj się z organizatorem: ${data.organizerName}.`}
          </p>
        )}
        <div>
          <h1 className="text-2xl font-bold">{data.tourName}</h1>
          <p className="text-neutral-500">{data.organizerName}</p>
        </div>

        <div className="flex flex-col gap-1">
          <span className="text-xs tracking-wide text-neutral-500">
            Numer rezerwacji
          </span>
          <span className="text-base font-semibold text-base-text">
            {data.bookingCode}
          </span>
        </div>

        <div className="flex flex-wrap gap-6 text-sm text-neutral-600">
          <div className="flex items-center gap-2">
            <CalendarDays className="size-4" />
            <span>
              {timeUtils.toDateRangeString(
                data.tourStartDate,
                data.tourEndDate,
              )}
            </span>
          </div>
          {/* Po anulowaniu liczba brzmiałaby „0 uczestników”. */}
          {!cancelled && (
            <div className="flex items-center gap-2">
              <Users className="size-4" />
              <span>
                {data.participantCount}{' '}
                {data.participantCount === 1 ? 'uczestnik' : 'uczestników'}
              </span>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

export default BookingSummaryHeader;
